import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-left"} maskId="square-filled-radius-0-stroke-1-IconArrowLeft"><path fillRule="evenodd" clipRule="evenodd" d="M11.4144 6.00003L6.41437 11H21.0002V13H6.41436L11.4144 18L10.0001 19.4142L2.58594 12L10.0002 4.58582L11.4144 6.00003Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowLeft;
